import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import { Fancybox } from "@fancyapps/ui";

Fancybox.bind('[data-fancybox="slider-video"]');

const selectors = {
  block: "[data-slider-video]",
};

const initSwiper = (container) =>
  new Swiper(container.querySelector(".swiper"), {
    slidesPerView: "auto",
    spaceBetween: 24,

    navigation: {
      prevEl: container.querySelector('[data-swiper-navigation="prev"]'),
      nextEl: container.querySelector('[data-swiper-navigation="next"]'),
    },

    pagination: {
      el: container.querySelector("[data-swiper-pagination]"),
    },
  });

const initBlock = (block) => {
  Swiper.use([Navigation, Pagination]);

  initSwiper(block);
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const blocks = document.querySelectorAll(selectors.block);

    blocks?.forEach(initBlock);
  },
  {
    once: true,
  }
);
